import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";

import { AuthProvider } from "./Components/auth/AuthContext";
import PrivateRoute from "./Components/auth/PrivateRoute";

import Login from "./Pages/LoginPage";
import DashboardLayout from "./Layout/DashboardLayout";
import DashboardHome from "./Pages/DashboardHome";
import AttendancePage from "./Components/AttendancePage";
import GroupMaster from "./Components/Masters/GroupMaster";
import RestaurantSubscriptionMaster from "./Components/Masters/RestaurantSubscriptionMaster";
import DepartmentMaster from "./Components/Masters/DepartmentMaster";
import DesignationMaster from "./Components/Masters/DesignationMaster";
import EmployeeMaster from "./Components/Masters/EmployeeMaster";
import RestaurantMaster from "./Components/Masters/RestaurantMaster";
import NewUserRegister from "./Components/OutletComponents/NewUserRegister";
import UserTypeMaster from "./Components/SystemUserComponents/UserTypeMaster";
import SysNewUserRegister from "./Components/SystemUserComponents/SysNewUserRegister";
import UserMaster from "./Components/SystemUserComponents/UserMaster";
import UserRole from "./Components/SystemUserComponents/UserRole";
import ModuleMaster from "./Components/SystemUserComponents/ModuleMaster";
import RoleMaster from "./Components/SystemUserComponents/RoleMaster";


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          {/* ✅ PUBLIC LOGIN */}
          <Route path="/login" element={<Login />} />

          {/* ✅ PROTECTED APP LAYOUT (both roles) */}
          <Route
            path="/"
            element={
              <PrivateRoute allowedRoles={["System Admin", "Super Admin"]}>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            {/* ✅ default redirect */}
            <Route index element={<Navigate to="dashboard" replace />} />

            {/* ✅ Dashboard (both roles) */}
            <Route
              path="dashboard"
              element={
                <PrivateRoute allowedRoles={["System Admin", "Super Admin"]}>
                  <DashboardHome />
                </PrivateRoute>
              }
            />

            {/* ✅ Attendance (both roles) */}
            <Route
              path="attendance"
              element={
                <PrivateRoute allowedRoles={["System Admin", "Super Admin"]}>
                  <AttendancePage />
                </PrivateRoute>
              }
            />

            {/* 🔐 Masters parent */}
            <Route path="masters">

              {/* ✅ SYSTEM_USER ONLY SECTION */}
              <Route
                element={
                  <PrivateRoute allowedRoles={["Super Admin"]}>
                    <Outlet />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="GroupMaster" replace />} />
                <Route path="GroupMaster" element={<GroupMaster />} />
                <Route path="RestaurantMaster" element={<RestaurantMaster />} />
                <Route path="RestaurantSubscriptionMaster" element={<RestaurantSubscriptionMaster />} />
                <Route path="UserTypeMaster" element={<UserTypeMaster />} />
                <Route path="ModuleMaster" element={<ModuleMaster />} />
                <Route path="RoleMaster" element={<RoleMaster />} />
                <Route path="SysNewUserRegister" element={<SysNewUserRegister />} />
                <Route path="UserMaster" element={<UserMaster />} />
                <Route path="UserRole" element={<UserRole />} />

              </Route>

              {/* ✅ ADMIN ONLY SECTION */}
              <Route
                element={
                  <PrivateRoute allowedRoles={["System Admin"]}>
                    <Outlet />
                  </PrivateRoute>
                }
              >
                 <Route path="NewUserRegister" element={<NewUserRegister />} />
                <Route path="DepartmentMaster" element={<DepartmentMaster />} />
                <Route path="DesignationMaster" element={<DesignationMaster />} />
                <Route path="employees" element={<EmployeeMaster />} />
              </Route>

            </Route>
          </Route>

          {/* ✅ catch all */}
          <Route path="*" element={<Navigate to="/login" replace />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;